<div class="modal fade" id="{{id}}" aria-hidden="true" aria-labelledby="Are you sure?"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">Are you sure?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-footer" style="justify-content: center;">
                <button class="btn btn-danger" data-bs-dismiss="modal" (click)="emitYes()">Yes</button>
                    <button class="btn btn-success" data-bs-dismiss="modal" (click)="emitNo()">No</button>
            </div>
        </div>
    </div>
</div>